import React from "react";
import styles from "./Tree.module.css";

function Tree({children}){
    return (
      <ul className={styles.tree}>{children}</ul>
    )
  };
  export default Tree;